import { useGraphql } from 'utils/hooks/useGraphql';

import { fetchShortLinksMinimumLengthQuery } from 'api/queries/templates';
import { SHORTLINKS_MIN_VALUE } from 'modules/projectSettings/constants';
import { TemplateAndContentFormDataLocale } from '../common';

export const useShortLinksLength = (initialTemplate: TemplateAndContentFormDataLocale) => {
  const shortLinkData = useGraphql(fetchShortLinksMinimumLengthQuery);
  const marketingLength =
    shortLinkData?.data?.getShortLinksMarketingMinimumLength || SHORTLINKS_MIN_VALUE;
  const transactionalLength =
    shortLinkData?.data?.getShortLinksTransactionalMinimumLength || SHORTLINKS_MIN_VALUE;

  const ChannelTypeShortLinkLengthLookup = {
    Marketing: marketingLength,
    Transactional: transactionalLength,
  };
  const channelType = initialTemplate?.messageType?.messageChannel?.channelType || '';
  // @ts-ignore we only support shortening for Marketing and Transactional SMS, safeguarding future channel types
  const shortlinkLength = ChannelTypeShortLinkLengthLookup[channelType] ?? SHORTLINKS_MIN_VALUE;
  return shortlinkLength;
};
